import React from 'react';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollAnswerViewer from '../../../DaEditorWrapper/Viewer/PollAnswer';
import pollStyles from './Poll.scss';
var VotableAnswers = function (_a) {
    var poll = _a.poll;
    return (React.createElement("ul", { className: pollStyles['answers'] }, poll.answers.map(function (_a) {
        var answerId = _a.answerId, image = _a.image, textContent = _a.textContent;
        return (React.createElement("li", { key: "answer:".concat(answerId), className: pollStyles['answer'] },
            React.createElement("div", { className: pollStyles['answer-row'] },
                image && (React.createElement(MinimalDumbo, { className: pollStyles['pollimage'], deviation: image, width: 72, height: 72 })),
                React.createElement(TextRenderer, { htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, className: classnames(pollStyles['answer-text'], 'da-editor-poll-thumb'), textContent: textContent, reactViewer: PollAnswerViewer, viewerKey: answerId }))));
    })));
};
export default VotableAnswers;
//# sourceMappingURL=VotableAnswers.js.map